// extracted by mini-css-extract-plugin
export var buttons = "bk_cr";
export var current = "bk_fz";
export var image = "bk_g";
export var marker = "bk_fy";
export var markers = "bk_fx";
export var p = "bk_fs";
export var promotions = "bk_fB";
export var section = "bk_d";
export var textContainer = "bk_cW";